import React, { memo, useMemo } from "react";
import BookingCard from "../BookingCard";
import { FloorplanBooking } from "../../floorplanTypes";

interface CommunalTableProps {
  bookings: FloorplanBooking[];
  width: number;
  colour: string;
  rotation: number;
  isDark?: boolean;
}

const CommunalTableComponent: React.FC<CommunalTableProps> = ({
  bookings,
  width,
  colour,
  rotation,
  isDark = false
}) => {
  const sectionWidth = width / 4;

  const sectionBookings = useMemo(() => bookings.slice(0, 4), [bookings]);

  return (
    <div
      className="absolute inset-0 rounded-2xl"
      style={{ backgroundColor: colour }}
    >
      {DIVIDERS.map((i) => (
        <div
          key={i}
          className="absolute top-1 bottom-1 pointer-events-none"
          style={{
            left: `${i * 25}%`,
            width: "1px",
            backgroundColor: isDark
              ? "rgba(255,255,255,0.05)"
              : "rgba(0,0,0,0.06)"
          }}
        />
      ))}

      <div className="absolute inset-0 flex">
        {sectionBookings.map((booking, index) => (
          <div key={booking.id ?? index} className="flex-1 relative">
            {booking && (
              <BookingCard
                booking={booking}
                rotation={rotation}
                shape="Rect"
                tableWidth={sectionWidth}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

const DIVIDERS = [1, 2, 3] as const;

export const CommunalTable = memo(CommunalTableComponent);
